import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Tabs, _React$Component);

  function Tabs(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      selected: props.tabIndex || 0
    };
    return _this;
  }

  var _proto = Tabs.prototype;

  _proto.selectTab = function selectTab(index) {
    this.setState({
      selected: index
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var children = this.props.children;
    return React.createElement("div", {
      className: "tabs"
    }, React.createElement("div", {
      className: "tab-buttons"
    }, children.map(function (child, index) {
      if (child) {
        return React.createElement("button", {
          key: "tab-" + index,
          className: "tab" + (_this2.state.selected === index ? ' selected' : ''),
          onClick: function onClick() {
            return _this2.selectTab(index);
          }
        }, child.props.name);
      }

      return null;
    })), children[this.state.selected]);
  };

  return Tabs;
}(React.Component);

export default Tabs;